import { EDITABLE_CARD_FEATURE } from '../../helpers/FeatureFlagName';
import { isFeatureEnabled } from 'owa-feature-flags';

export default function isEditableCardSupported(): boolean {
    return isFeatureEnabled(EDITABLE_CARD_FEATURE);
}
